import * as React from 'react'
import styled from 'styled-components/macro'

const BasicButtton = styled.button`
  font-family: 'Rubik';
  display: flex;
  justify-content: center;
  text-transform: uppercase;
  padding: 12px 24px;
  font-weight: 700;
  color: white;
  background-color: var(--dark-blue) !important;
  border: 0;
  border-radius: 0 !important;
  width: fit-content !important;
  :hover {
    background-color: var(--dark-blue) !important;
  }
`

const Button = ({className}) => {
  return (
    <BasicButtton className={className} onClick={() => {}}>
      Local Only
    </BasicButtton>
  )
}
export default Button
